import { APPLICATION_VERSION_SUPPORTED_OP } from './constants';

export function isAppSupportedOp(op: string) {
  return op === APPLICATION_VERSION_SUPPORTED_OP;
}
